import React, { Suspense } from "react";

const CompanyConquestingJobCards = React.lazy(() =>
  import(
    /* webpackChunkName: "company-conquesting-job-cards" */
    "./CompanyConquestingJobCards"
  ).then((module) => ({ default: module.CompanyConquestingJobCards })),
);

export function LazyCompanyConquestingJobCards(props: {
  readonly jobKey: string;
  readonly loggedIn: boolean;
}) {
  return (
    <Suspense fallback={null}>
      <CompanyConquestingJobCards {...props} />
    </Suspense>
  );
}
